<template>
  <router-view />
</template>

<script>
  import '@/styles/overrides.sass'
  import '@koumoul/vjsf/lib/VJsf.css'
  import '@koumoul/vjsf/lib/deps/third-party.js'
  import EasyMDE from 'easymde/dist/easymde.min.js'
  import 'easymde/dist/easymde.min.css'  
  import { mapActions } from 'pinia'
  import { useAppStore } from '@/store/app-store'

  global.EasyMDE = EasyMDE

  export default {
    name: 'App',
    metaInfo: {
      title: 'App',
      titleTemplate: 'ownR | infinity',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
    mounted () {
      this.loadAllApps()
      setInterval(this.loadAllApps, 5000)
    },
    methods: {
      ...mapActions(useAppStore, ['loadAllApps']),
    },
  }
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
</style>
